module.exports = __webpack_public_path__ + "img/ad_main2.e1e9052a.png";